module.exports = __webpack_public_path__ + "media/icons/calender-f5230316.svg";